<template>
  <div class="site-footer critical-component-clear grid">
    <div class="site-footer__container site-footer__container-primary grid col xs-span l8 xl9">
      <div
        class="col site-footer__columns site-footer__columns-main xs-span l3 xl3"
        v-html="mainMenu"
      />
      <div class="col site-footer__columns site-footer__columns-secondary grid xs-span l6 xl6">
        <div
          v-for="(block, index) of menuBlocks"
          :key="block.id"
          class="col xs-span l3 xl2 site-footer__column"
          :class="{
            'site-footer__mobile-accordion': isMobile,
          }"
        >
          <button
            v-if="isMobile"
            :id="`${block.title + index}-control`"
            class="
              site-footer__mobile-accordion-control
              site-footer__column-title text-heading-m text-heading-2xs-desktop
            "
            :aria-expanded="getActiveState(index)"
            type="button"
            :aria-controls="`${block.title + index}-content`"
            @click="setActiveItem(index)"
          >
            <span v-text="block.title" />
            <span
              class="
                site-footer__link-icons
                site-footer__mobile-accordion-icons
              "
            >
              <icon-plus
                :class="{
                  show: !getActiveState(index)
                }"
              />
              <icon-minus
                :class="{
                  show: getActiveState(index)
                }"
              />
            </span>
          </button>
          <p
            v-else
            class="site-footer__column-title text-heading-m text-heading-2xs-desktop"
            v-text="block.title"
          />
          <transition-height>
            <ul
              v-if="block.links"
              v-show="getActiveState(index) || !isMobile"
              :id="`${block.title + index}-content`"
              role="region"
              :aria-labelledby="`${block.title + index}-control`"
              class="site-footer__list collapsed"
            >
              <li
                v-for="link of block.links"
                :key="link.id"
              >
                <a
                  class="text-link-regular"
                  :href="link.url"
                  v-html="link.title"
                />
              </li>
            </ul>
          </transition-height>
        </div>
      </div>
      <div class="col site-footer__columns site-footer__columns-tertiary grid xs-span">
        <div
          v-if="locationToggle"
          class="col xs-span l6"
        >
          <country-selector-btn
            :mobile-flag-only="false"
            location="footer"
          />
        </div>
        <div
          class="site-footer__payments site-footer__payments-desktop col xs-span l6"
          v-html="paymentIconsDesktop"
        />
        <div
          class="col xs-span site-footer__legal"
          v-html="legal"
        />
      </div>
    </div>
    <div
      class="
        site-footer__container site-footer__container-secondary
        site-footer__columns col xs-span l4 xl3
      "
    >
      <div
        class="site-footer__contact-container"
        v-html="contact"
      />
      <div
        v-if="locationToggle"
        class="site-footer__country-selector-mobile"
      >
        <country-selector-btn
          :mobile-flag-only="false"
          location="footer"
        />
      </div>
      <div
        class="site-footer__payments"
        v-html="paymentIcons"
      />
      <div
        class="site-footer__legal"
        v-html="legal"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Site footer (site-footer)
 * -----------------------------------------------------------------------------
 * Site footer component with accordion display of links.
 *
 */
import { mapState } from 'vuex'

import CountrySelectorBtn from '~global/country-selector-btn/country-selector-btn'
import TransitionHeight from '~global/transition-height/transition-height'
import IconMinus from '~icons/directional-navigation/minus.svg'
import IconPlus from '~icons/directional-navigation/plus.svg'

export default {
  name: 'SiteFooter',

  components: {
    CountrySelectorBtn,
    TransitionHeight,
    IconMinus,
    IconPlus,
  },

  props: {
    mainMenu: {
      type: String,
      default: '',
    },
    menuBlocks: {
      type: Array,
      default: () => [],
    },
    contact: {
      type: String,
      default: '',
    },
    paymentIcons: {
      type: String,
      default: '',
    },
    paymentIconsDesktop: {
      type: String,
      default: '',
    },
    legal: {
      type: String,
      default: '',
    },
    locationToggle: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      active: [],
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },
 
  mounted() {
      
    window.addEventListener("DOMContentLoaded", function() {
          //setTimeout(function(){Invoca.PNAPI.run(); }, 2000);
          if(this.isMobile){
            //setTimeout(function(){Invoca.PNAPI.run(); }, 2000);
            
          }
        })
      },
  
  methods: {

    /**
     * Returns the active state of the given index.
     * @param {Number} index - The item index.
     * @returns {Boolean}
     */
    getActiveState(index) {
      return this.active.includes(index)
    },

    /**
     * Toggles an active item.
     * @param {Number} index - The index of the item to activate.
     */
    setActiveItem(index) {
      if (this.getActiveState(index)) {
        this.active = this.active.filter((item) => item !== index)
        return
      }

      this.active.push(index)
    },
  },
}
</script>

<style lang="scss">
@import './site-footer';
</style>
